import Api from '../Api';

export const getStyles = () => async dispatch => {
  const { data } = await Api.get('/styles');
  dispatch({
    type: 'FETCH_STYLES',
    payload: data,
  });
};

export const clearStyles = () => {
  return {
    type: 'CLEAR_STYLES',
  };
};

export const getStyle = id => async dispatch => {
  const { data } = await Api.get(`/styles/${id}`);

  dispatch({
    type: 'FETCH_STYLE',
    payload: data,
  });
};

export const clearStyle = () => {
  return {
    type: 'CLEAR_STYLE',
  };
};

export const getStylesForJobchart = customerId => async dispatch => {
  const { data } = await Api.get(`/styles/forjobchart/${customerId}`);

  dispatch({
    type: 'FETCH_STYLES_FOR_JOBCHART',
    payload: data,
  });
};

export const clearStylesForJobchart = () => {
  return {
    type: 'CLEAR_STYLES_FOR_JOBCHART',
  };
};

export const getJobchartStylesForRpo = jobchartId => async dispatch => {
  const { data } = await Api.get(
    `/jobcharts/stylesfordailycompletion/${jobchartId}`
  );

  dispatch({
    type: 'FETCH_JOBCHART_STYLES_FOR_RPO',
    payload: data,
  });
};

export const clearJobchartStylesForRpo = () => {
  return {
    type: 'CLEAR_JOBCHART_STYLES_FOR_RPO',
  };
};
